export { Avatar, avatarVariants, type AvatarProps } from './Avatar'
